import React, { useState } from "react";
import { useDispatch } from "react-redux";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function FinListDrivingLicence({
  token,
  titles = [],
  list = [],
  callBack,
}) {
  const dispatch = useDispatch();
  const [searchWords, setSearchWords] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [newCurrentList, setNewCurrentList] = useState([]);
  const [indexValue, setIndex] = useState(10);
  var appliedTilteList = [
    "SR.NO.",
    "VISA PROVIDER",
    "CLIENT NAME",
    "Employee COUNT",
    "SPONSOR ID",
    "status",
  ];

  const handleCheckboxChange = (event, id) => {
    const isChecked = event.target.checked;
    if (id === "all") {
      const updatedCheckedItems = {};
      currentList.forEach((item) => {
        updatedCheckedItems[item.employee_id] = isChecked;
      });
      setCheckedItems(updatedCheckedItems);
    } else {
      setCheckedItems((prevState) => ({
        ...prevState,
        [id]: isChecked,
      }));
    }
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(newCurrentList || []);


  const drivingApi = async (type) => {
    try {
      const res = await nodeinstance.post(
        "/drivingLicense/updatestatus/",
        type,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        callBack();
        setCheckedItems({});
        // navigate(`/dashboard/driving-licence`, { state: { id: "1" } });
      } else {
        dispatch(
          setAppError({
            msg: err?.response?.error,
          })
        );
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error,
        })
      );
    }
  };

  const popOpen = () => {
    if (
      Object.entries(checkedItems)
        .filter(([emp_id, isChecked]) => isChecked)
        .map(([emp_id]) => emp_id).length === 0
    ) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      if (dataList.length !== 0) {
        console.log(popUpFlag);
        if (popUpFlag === false) {
          console.log("popUpFlag", popUpFlag);
          drivingApi({
            employee_id: dataList.map((e) => e.employee_id),
            driving_status: statusCode,
          });
        } else {
          console.log("popUpFlag", popUpFlag);
          console.log(popUpFlag);
          setPopUp(true);
        }
      } else {
        dispatch(
          setAppError({
            msg: "Please Select Vaild Emp",
          })
        );
      }
    }
  };
  return (
    <>
      <div className="relative bg-white m-2">
        <div className="overflow-x-auto max-h-[70vh]">
          <div className="sticky top-0 z-10 min-w-[1000px]">
            <div className="grid grid-cols-table-ajeer-applied gap-5 p-6 text-center">
              {appliedTilteList.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div>
            {list?.data.isLoading && (
              <LoadingWithLable className="col-span-6" />
            )}
            {list?.isLoading && <NoDataFound />}
            {!list?.isLoading
              ? list?.listData.map((listData, index) => (
                <a
                  key={index}
                  onClick={() => {
                    const filteredData = list?.data.filter(
                      (indexData) =>
                        indexData.visa_provider === listData.visa_provider &&
                        indexData.client_name === listData.client_name &&
                        indexData.driving_status === listData.driving_status
                    );
                    setNewCurrentList(filteredData);
                    setIndex(index);
                  }}
                  className={`grid grid-cols-table-ajeer-applied auto-cols-min gap-5 p-4 text-center ${indexValue === index ? "bg-orange-50" : "bg-white"} rounded-md `}
                  style={{ cursor: "pointer" }} // Apply pointer cursor style
                >
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.visa_provider || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.client_name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={
                          listData.employee_count.toString() || "-"
                        }
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.sponsor_id || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={listData.driving_status || "-"}
                      />
                    </p>
                    {/* {indexValue === index ? <></> : <hr
                    className={`border-[1px] border-slate-100  w-full col-span-full `}
                  />} */}
                  </React.Fragment>
                </a>
              ))
              : ""}
          </div>
        </div>
      </div>

      {currentList.length !== 0 ? (
        <>
          <div className="flex flex-wrap  gap-2 w-full items-center flex flex-row-reverse space-x-reverse">
            <Search
              searchKey={[
                "employee_id",
                "name",
                "actual_profession",
                "visa_profession",
                "visa_provider",
                "client_name",
                "iqama_number",
                "license_type"
              ]}
              setSearchWords={setSearchWords}
            />
            <button
              className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
              onClick={() =>
                drivingApi({
                  employee_id: Object.entries(checkedItems)
                    .filter(([emp_id, isChecked]) => isChecked)
                    .map(([emp_id]) => emp_id),
                  driving_status: 4,
                })
              }
            >
              <p>Update status Payment done</p>
            </button>

            <div className="gap-2 items-center flex flex-row"></div>
          </div>
          <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>
          <CountPerPage />
          <div className="relative bg-white">
            <div className="overflow-x-auto max-h-[70vh] ">
              <div className="sticky top-0 z-10 bg-white min-w-[2550px]">
                <div className="grid grid-cols-table-update-lic gap-5 p-6 text-center">
                  {titles.map((t, index) => (
                    <p key={index} className="font-semibold uppercase">
                      {t}
                    </p>
                  ))}
                </div>
              </div>
              <div className="grid grid-cols-table-update-lic gap-5 p-6 bg-white text-center">
                {list?.isLoading && (
                  <LoadingWithLable className="col-span-full" />
                )}
                {!list?.isLoading && <NoDataFound />}
                {!list?.isLoading &&
                  currentList.map((list, index) => (
                    <React.Fragment key={index}>
                      <PaginationIndex index={index} />
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.employee_id || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.actual_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_profession || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.visa_provider || "-"}
                        />
                      </p>
                      <p className="overflow-x-hidden">
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.sponsor || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.client_name || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.iqama_number || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.license_type || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.apply_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.issue_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.expiry_date || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.valid_days || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.admission_fee || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.medical_fee || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.govt_fee || "-"}
                        />
                      </p>

                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.govt_fee || "-"}
                        />
                      </p>
                      <p>
                        <Highlighter
                          searchWords={searchWords}
                          autoEscape={true}
                          textToHighlight={list.driving_status || "-"}
                        />
                      </p>
                      <div >
                        <input
                          disabled={
                            list.driving_status === "Payment Pending"
                              ? false
                              : true
                          }
                          key={list.employee_id} // Use a unique identifier as the key
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id)
                          }
                        />
                      </div>

                      <hr
                        className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                      />
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>

          <Pagination />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
